import { graphql } from "react-relay";

export const GENERATE_LINEUPS = graphql`
  mutation GenerateLineupsMutation(
    $input: GenerateLineupsForGreenMachineSessionInput!
  ) {
    generateLineupsForGreenMachineSession(input: $input) {
      success
    }
  }
`;
